import React from "react";

function Contact() {
  return (
    <main className="container mx-auto max-width pt-10 mb-20">
      <section className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
        
        {/* 🇺🇸 English Privacy Policy */}
        <div className="bg-transparent rounded-xl mt-10 overflow-hidden shadow-xl shadow-slate-300 dark:shadow-slate-900 p-4 md:p-6 space-y-4">

          <h1 className="text-2xl md:text-3xl font-bold text-dark-heading dark:text-light-heading">
            🇺🇸 Privacy Policy
          </h1>

          <div>
            <h3 className="text-sm font-semibold text-dark-heading dark:text-light-heading">
              Privacy Policy — QR Dess Code
            </h3>
            <p className="text-xs text-dark-content dark:text-light-content">
              Last updated: January 29, 2026
            </p>
          </div>

          <p className="text-xs text-dark-content dark:text-light-content">
            The QR Dess Free application respects user privacy.
          </p>

          <div>
            <h2 className="text-xl font-semibold text-dark-heading dark:text-light-heading mb-2">
              Data Collection
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              The application does not collect, store, transmit, or share any personal data.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Camera Usage
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              The application may use the device’s camera solely for QR code scanning purposes.
              Captured images are processed locally on the device and are never uploaded,
              stored, or transmitted.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Technical Data
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              No analytics, tracking, advertising, or usage data is collected.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              User Accounts
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              No user account is required to use the application.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-dark-heading dark:text-light-heading mb-2">
              Third-Party Services
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              The application does not use any third-party analytics, advertising, or tracking services.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-dark-heading dark:text-light-heading mb-2">
              Contact
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              For any questions:{" "}
              <a
                href="mailto:contact.qrdessfree@gmail.com"
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                contact.qrdesscode@gmail.com
              </a>
            </p>
          </div>

        </div>

        {/* 🇫🇷 French Privacy Policy */}
        <div className="bg-transparent rounded-xl mt-10 overflow-hidden shadow-xl shadow-slate-300 dark:shadow-slate-900  p-4 md:p-6 space-y-4">

          <h1 className="text-2xl md:text-3xl font-bold text-dark-heading dark:text-light-heading">
            🇫🇷 Politique de confidentialité
          </h1>

          <div>
            <h3 className="text-sm font-semibold text-dark-heading dark:text-light-heading">
              Politique de confidentialité — QR Dess Code
            </h3>
            <p className="text-xs text-dark-content dark:text-light-content">
              Dernière mise à jour : 29 janvier 2026
            </p>
          </div>

          <p className="text-xs text-dark-content dark:text-light-content">
            L’application QR Dess Free respecte la vie privée des utilisateurs.
          </p>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Données collectées
            </h2>
            <p className=" text-xs text-dark-content dark:text-light-content">
              L’application ne collecte, ne stocke, ne transmet et ne partage aucune donnée personnelle.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Caméra
            </h2>
            <p className=" text-xs text-dark-content dark:text-light-content">
              L’application peut utiliser la caméra de l’appareil uniquement pour la lecture de QR codes.
              Les images capturées sont traitées localement sur l’appareil et ne sont jamais transmises à un serveur.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Données techniques
            </h2>
            <p className=" text-xs text-dark-content dark:text-light-content">
              Aucune donnée d’usage, statistique, publicitaire ou de suivi n’est collectée.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-dark-heading dark:text-light-heading mb-2">
              Comptes
            </h2>
            <p className=" text-xs text-dark-content dark:text-light-content">
              L’application ne nécessite pas la création de compte utilisateur.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Services tiers
            </h2>
            <p className="text-xs text-dark-content dark:text-light-content">
              L’application n’utilise aucun service tiers d’analyse, de publicité ou de suivi.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-dark-heading dark:text-light-heading mb-2">
              Contact
            </h2>
            <p className=" text-xs text-dark-content dark:text-light-content">
              Pour toute question :{" "}
              <a
                href="mailto:contact.qrdessfree@gmail.com"
                className="text-blue-600 dark:text-blue-400 hover:underline"
              >
                contact.qrdesscode@gmail.com
              </a>
            </p>
          </div>

        </div>

        

      </section>
    </main>
  );
}


export default Contact;
